import { create } from 'zustand';

export type TravelMode = 'car' | 'walk' | 'transit' | 'bicycle';

interface DirectionsState {
  // Điểm xuất phát và đích
  origin: string;
  destination: string;
  
  // Phương thức di chuyển
  travelMode: TravelMode;
  
  // Lịch sử tìm kiếm
  recentDestinations: string[];
  
  // Trạng thái
  isSearching: boolean;
  directionsUrl: string | null;
  
  // Actions
  setOrigin: (origin: string) => void;
  setDestination: (destination: string) => void;
  setTravelMode: (mode: TravelMode) => void;
  addRecentDestination: (destination: string) => void;
  clearRecentDestinations: () => void;
  setSearching: (searching: boolean) => void;
  setDirectionsUrl: (url: string | null) => void;
  clearForm: () => void;
}

export const useDirectionsStore = create<DirectionsState>((set) => ({
  // State
  origin: '',
  destination: '',
  travelMode: 'car',
  recentDestinations: [],
  isSearching: false,
  directionsUrl: null,
  
  // Actions
  setOrigin: (origin) => set({ origin }),
  
  setDestination: (destination) => set({ destination }),
  
  setTravelMode: (mode) => set({ travelMode: mode }),
  
  addRecentDestination: (destination) => set((state) => {
    const destinations = [destination, ...state.recentDestinations.filter(d => d !== destination)];
    return { recentDestinations: destinations.slice(0, 5) }; // Giữ tối đa 5 địa điểm
  }),
  
  clearRecentDestinations: () => set({ recentDestinations: [] }),
  
  setSearching: (searching) => set({ isSearching: searching }),
  
  setDirectionsUrl: (url) => set({ directionsUrl: url }),
  
  clearForm: () => set({
    origin: '',
    destination: '',
    travelMode: 'car',
    directionsUrl: null,
  }),
}));